import cs from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { Button, Popup, Tabs, Toast } from 'zarm';
import { isPreviewMode } from '@/utils/tool';
import ConfirmTip from '../confirmTip';
import BubbleTip from '../popupBubble';
import TabContent from '../tabContent';
import TabList from '../tabList';
import './index.less';
const Title = styled.div`
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  line-height: 45px;
`;

const useVisible = initialVisible => {
  const initShow = !isPreviewMode() && initialVisible; // const [visible, setVisible] = useCacheStateByPage('supervisionPopupVisible', initShow);

  const [visible, setVisible] = useState(initShow);
  return [visible, setVisible];
};

const {
  Panel
} = Tabs;
/**
 * 健康告知的弹出层
 * @param {*} param0
 */

const SupervisionPopup = props => {
  var _dataSource$value, _dataSource$value2, _dataSource$value3, _dataSource$value4;

  const {
    attrs = {},
    id
  } = props;
  const {
    buttonText = '',
    dataSource = [],
    visible = false
  } = attrs; // const moduleConfig = useCurrentModule();
  // 如果是tabs的情况，是否开启禁止所有tab，并点击按钮跳转到下一个tab

  const limitStep = true; // 默认开启点击按钮跳转到下一步，后续通过配置选择是否开启

  const [disabled, setDisabled] = useState(limitStep);
  const [show, setShow] = useVisible(visible);
  const [value, setValue] = useState(0);
  const box = useRef();
  const contentRef = useRef();

  const handleClose = () => {
    if (isPreviewMode()) {
      return;
    }

    setShow(false);
  };

  const initTab = index => {
    const list = box.current;
    const tabs = list === null || list === void 0 ? void 0 : list.getElementsByClassName('za-tabs__tab');

    if (!list || !tabs) {
      return;
    }

    const scroll = list === null || list === void 0 ? void 0 : list.getElementsByClassName('za-tabs__scroll')[0];
    const ul = scroll === null || scroll === void 0 ? void 0 : scroll.getElementsByTagName('ul')[0];
    const curr = tabs[index];
    const currOb = curr === null || curr === void 0 ? void 0 : curr.getBoundingClientRect();
    const left = currOb.left - currOb.width / 2;

    if (ul) {
      ul.scrollTo({
        top: 0,
        left,
        behavior: 'smooth'
      });
    }
  };

  const changeTab = index => {
    const list = document.getElementsByClassName('popup-box')[0];
    const tabs = list === null || list === void 0 ? void 0 : list.getElementsByClassName('za-tabs__tab');
    const scroll = list === null || list === void 0 ? void 0 : list.getElementsByClassName('za-tabs__scroll')[0];
    const ul = scroll === null || scroll === void 0 ? void 0 : scroll.getElementsByTagName('ul')[0];
    const curr = tabs[index];
    const first = tabs[0];
    const currOb = curr === null || curr === void 0 ? void 0 : curr.getBoundingClientRect();
    const ulOb = ul === null || ul === void 0 ? void 0 : ul.getBoundingClientRect();
    const firstOb = first === null || first === void 0 ? void 0 : first.getBoundingClientRect();
    const line = list === null || list === void 0 ? void 0 : list.getElementsByClassName('za-tabs__line')[0];
    const firstLeft = firstOb.x < 0 ? -firstOb.x : firstOb.x; // 自动将tab移动到屏幕中间

    const clientWidth = document.body.offsetWidth;
    const left = (clientWidth - currOb.width) / 2;
    const scrollDiv = document.getElementsByClassName('za-tabs__tablist')[0];
    const scrollLeft = firstLeft + currOb.x;
    scrollDiv.scrollLeft = scrollLeft - left;
    line.style = '';
    line.style.display = 'none';
    setTimeout(() => {
      line.style.width = `${currOb.width * 4 / 4}px`;
      line.style.transform = '';
      line.style.display = 'block';
      line.style.position = 'absolute';
      line.style.left = `${firstLeft + currOb.x}px`;
    }, 100);
  };

  const handleScroll = () => {};

  useEffect(() => {
    setShow(visible);
  }, [visible]);
  useEffect(() => {
    if (!isPreviewMode()) {
      setTimeout(() => {
        setShow(true);
      }, 100);
    }
  }, []);
  useEffect(() => {
    if (isPreviewMode() || typeof show === 'undefined') {
      return;
    }

    if (show) {
      document.documentElement.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '0px';
      document.body.style.width = '100%';
    } else {
      document.documentElement.style.overflow = 'scroll';
      document.body.style.position = 'static';
    }

    return () => {
      document.documentElement.style.overflow = 'scroll';
      document.body.style.position = 'static';
    };
  }, [show]);
  useEffect(() => {
    if (show) {
      setTimeout(() => {
        initTab(value);
        changeTab(value);
      }, 500);
    }
  }, [show]);
  const cls = cs('c-supervisionPopup-bottom-bubble', {
    noTip: !((_dataSource$value = dataSource[value]) !== null && _dataSource$value !== void 0 && _dataSource$value.specialDesc.enable)
  });
  const clsTip = cs('c-supervisionPopup-bottom-tip', {});
  return /*#__PURE__*/React.createElement("div", {
    id: "fdasfdas"
  }, show && /*#__PURE__*/React.createElement(Popup, {
    visible: true,
    direction: "bottom",
    id: id,
    destroy: true,
    mountContainer: () => document.getElementById('fdasfdas')
  }, /*#__PURE__*/React.createElement(GlobalStyled, null), /*#__PURE__*/React.createElement("div", {
    ref: box,
    className: `popup-box ${visible ? '' : 'no-visible'}`
  }, /*#__PURE__*/React.createElement(Tabs, {
    disabled: disabled,
    value: value,
    onChange: v => {
      setValue(v);
      changeTab(v);
    },
    scrollThreshold: 3
  }, dataSource && dataSource.map((item, index) => /*#__PURE__*/React.createElement(Panel, {
    key: item.title,
    title: /*#__PURE__*/React.createElement(Title, null, item.title)
  }, item.style === 'content' && value === index && /*#__PURE__*/React.createElement(TabContent, {
    ref: contentRef,
    onScroll: handleScroll,
    content: item.content,
    style: {
      paddingBottom: '70'
    }
  }), item.style === 'list' && /*#__PURE__*/React.createElement(TabList, {
    ref: contentRef,
    tabValue: value,
    list: item.list
  })))), /*#__PURE__*/React.createElement("div", {
    className: "c-supervisionPopup-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: cls
  }, /*#__PURE__*/React.createElement(BubbleTip, {
    attrs: (_dataSource$value2 = dataSource[value]) === null || _dataSource$value2 === void 0 ? void 0 : _dataSource$value2.tooltip,
    tabIndex: value
  })), ((_dataSource$value3 = dataSource[value]) === null || _dataSource$value3 === void 0 ? void 0 : _dataSource$value3.specialDesc.enable) && /*#__PURE__*/React.createElement("div", {
    className: clsTip
  }, /*#__PURE__*/React.createElement(ConfirmTip, {
    text: (_dataSource$value4 = dataSource[value]) === null || _dataSource$value4 === void 0 ? void 0 : _dataSource$value4.specialDesc.value[0]
  })), /*#__PURE__*/React.createElement("div", {
    className: "c-supervisionPopup-bottom-button"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-confirmButton-component 456"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "confirmButton",
    block: true,
    theme: "primary",
    onClick: handleClose
  }, buttonText)))))));
};

export default SupervisionPopup;
const GlobalStyled = createGlobalStyle`
  body {
    overflow: hidden;
  }
`;